"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeProductTypeDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const license_pages_1 = require("@dzambalaorg/license-pages");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const store_1 = require("../global/store");
const UpgradeProductTypeDialog = (props) => {
    const { open } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const closeDialog = (0, store_1.useGlobalFormDialogStore)(state => state.closeDialog);
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.Dialog, { onClose: closeDialog, open: open, maxWidth: "lg", children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Dialog.Title, { title: formatMessage({ id: "pages.productType.dialog.title" }) }), (0, jsx_runtime_1.jsxs)(ui_kit_1.Dialog.Content, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { variant: "h6", fontSize: 16, fontWeight: 500, marginBottom: 2, children: formatMessage({ id: "pages.productType.dialog.text" }) }), (0, jsx_runtime_1.jsx)(license_pages_1.ProductTypeSelection, {})] })] }));
};
exports.UpgradeProductTypeDialog = UpgradeProductTypeDialog;
//# sourceMappingURL=index.js.map